/* eslint-disable camelcase */
import { Map, fromJS } from 'immutable'
import _get from 'lodash/get'
import _set from 'lodash/set'
import { createLocationHref } from 'services/location'
import {
  getUserGcsiSubscription as getUserGcsiSubscriptionAction,
  setUserGcsiSubscription as setUserGcsiSubscriptionAction,
  getUserLastTransaction as getUserLastTransactionAction,
  setUserLastTransaction as setUserLastTransactionAction,
  setUserProcessing as setUserProcessingAction,
  setUserError as setUserErrorAction,
  setProfiles as setProfilesAction,
  updateUserEntitlementSuccess,
  createUserEntitlementSuccess,
  updateUserEntitlementError,
  createUserEntitlementError,
  setUser as setUserAction,
  clearUserEntitlements,
  resetUserBlockSuccess,
  resetUserBlockError,
  setSimulationError,
  setSimulationData,
  updateUserSuccess,
  createUserSuccess,
  updateUserError,
  createUserError,
  changeAccountOwnerSuccess,
  changeAccountOwnerError,
  GET_USER_BY_GCSI_USER_UUID,
  GET_USER_LAST_TRANSACTION,
  GET_USER_GCSI_SUBSCRIPTION,
  UPDATE_USER_ENTITLEMENT,
  CREATE_USER_ENTITLEMENT,
  GET_USER_BY_UUID,
  RESET_USER_BLOCK,
  GET_USER_BY_UID,
  SIMULATE_USER,
  CREATE_USER,
  UPDATE_USER,
  CREATE_USER_SUCCESS,
  ANONYMIZE_USER_DATA,
  anonymizeUserDataSuccess,
  anonymizeUserDataError,
  GRANT_USER_BONUS,
  grantUserBonusDataSuccess,
  grantUserBonusDataError,
  CHANGE_ACCOUNT_OWNER,
} from './actions'

import {
  simulateUser as apiSimulateUser,
  getUserGcsiSubscription,
  getUserLastTransaction,
  updateUserEntitlement,
  createUserEntitlement,
  getUserByGcsiUserUuid,
  getUserByUuid,
  getUserByUid,
  getProfiles,
  unblockUser,
  createUser,
  updateUser,
  anonymizeUserData,
  grantUserBonusData,
  changeAccountOwner,
} from '../index'

const log = console
const storeKey = 'userDetail'

async function simulateUser ({ store, action }) {
  const { payload } = action
  const { uid } = payload
  const { getState, dispatch } = store
  const { auth, config } = getState()

  const webApp = config.getIn(['data', 'servers', 'webApp'])
  const webAppHostname = webApp.replace(/^https:\/\//, '')

  try {
    const data = await apiSimulateUser({
      server: config.getIn(['data', 'servers', 'brooklyn']),
      cookie: { include: true, domain: webAppHostname },
      auth,
      uid,
    })
    dispatch(
      setSimulationData({
        value: data.getIn(['cookie', 'value']),
        path: `${webApp}/simulate`,
        storeKey,
      }),
    )
  } catch (e) {
    dispatch(setSimulationError(storeKey))
  }
}

async function getUserHandler ({ store, action }) {
  const { payload } = action
  const { uuid, uid, gcsiUserUuid } = payload
  const { config = Map(), auth = Map() } = store.getState()

  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      uuid,
      uid,
      gcsiUserUuid,
    }
    store.dispatch(setUserProcessingAction({ storeKey, processing: true }))

    // use the get method for whichever identifier we've been provided
    let resData
    if (uid) {
      resData = await getUserByUid(options)
    } else if (uuid) {
      resData = await getUserByUuid(options)
    } else if (gcsiUserUuid) {
      resData = await getUserByGcsiUserUuid(options)
    }
    store.dispatch(
      setUserAction({
        storeKey,
        data: resData,
      }),
    )

    options.user_account_id = resData.get('user_account_id')
    const profileData = await getProfiles(options)

    store.dispatch(
      setProfilesAction({
        data: profileData,
      }),
    )

    store.dispatch(
      getUserLastTransactionAction({
        storeKey,
        uid: resData.get('uid'),
      }),
    )
    const gcsiId = resData.get('gcsi_user_uuid')
    if (gcsiId) {
      store.dispatch(
        getUserGcsiSubscriptionAction({
          storeKey,
          gcsiUserUuid: gcsiId,
        }),
      )
    }
  } catch (error) {
    log.error(error, 'Error searching for user.')
    store.dispatch(
      setUserErrorAction({
        storeKey,
        error: parseUserError(error),
      }),
    )
  }
}

async function getUserLastTransactionHandler ({ store, action }) {
  const { payload } = action
  const { uid } = payload
  const { config = Map(), auth = Map() } = store.getState()

  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
      uid,
    }
    store.dispatch(setUserProcessingAction({ storeKey, processing: true }))
    const resData = await getUserLastTransaction(options)
    store.dispatch(
      setUserLastTransactionAction({
        storeKey,
        data: resData,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting user last transaction.')
    store.dispatch(
      setUserErrorAction({
        storeKey,
        error: parseUserError(error),
      }),
    )
  }
}

async function getUserGcsiSubscriptionHandler ({ store, action }) {
  const { payload } = action
  const { gcsiUserUuid } = payload
  const { config = Map(), auth = Map() } = store.getState()

  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      gcsiUserUuid,
    }
    store.dispatch(setUserProcessingAction({ storeKey, processing: true }))
    let resData
    try {
      resData = await getUserGcsiSubscription(options)
    } catch (err) {
      resData = fromJS({})
    }
    store.dispatch(
      setUserGcsiSubscriptionAction({
        storeKey,
        data: resData,
      }),
    )
  } catch (error) {
    log.error(error, 'Error getting user last transaction.')
    store.dispatch(
      setUserErrorAction({
        storeKey,
        error: parseUserError(error),
      }),
    )
  }
}

async function resetUserBlockHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { uuid } = action.payload
  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      uuid,
    }
    await unblockUser(options)
    store.dispatch(
      resetUserBlockSuccess({
        storeKey,
        uuid,
      }),
    )
  } catch (error) {
    log.error(error, 'Error searching for user.')
    store.dispatch(
      resetUserBlockError({
        storeKey,
        error,
        uuid,
      }),
    )
  }
}

const parseUserError = (error) => {
  const errorBody = JSON.parse(_get(error, ['response', 'text']))
  const { title, detail, meta } = errorBody.errors?.[0] ?? {}
  if (title === 'Conflict') {
    return 'Username or Email is already in use. Please select another.'
  }

  const err = `${detail} ${meta}`
  return err
}

const parseError = (error) => {
  const errorBody = _get(error, 'response.body')
  return _get(errorBody, ['errors', 0, 'meta', 0])
}

async function createUserHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const data = _get(action.payload, 'data')
  const first_name = _get(data, 'first_name')
  const last_name = _get(data, 'last_name')
  const billing_account_id = _get(data, 'billing_account_id')
  const billing_account_number = _get(data, 'billing_account_number')
  const userData = {
    username: _get(data, 'username'),
    email: _get(data, 'email'),
    password: _get(data, 'password'),
    user_entitlements: _get(data, 'user_entitlements'),
    user_roles: _get(data, 'user_roles'),
    gcsi_user_uuid: _get(data, 'gcsi_user_uuid'),
    status: _get(data, 'status') || 'active',
    language: _get(data, 'language' || 'en'),
    member_support_notes: _get(data, 'member_support_notes', ''),
  }

  // the following fields are not required, so check to see if they are there
  if (first_name) {
    _set(userData, 'first_name', first_name)
  }

  if (last_name) {
    _set(userData, 'last_name', last_name)
  }

  if (billing_account_id) {
    _set(userData, 'billing_account_id', billing_account_id)
  }

  if (billing_account_number) {
    _set(userData, 'billing_account_number', billing_account_number)
  }

  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      body: userData,
    }
    const res = await createUser(options)
    store.dispatch(
      createUserSuccess({
        storeKey,
        data: fromJS(res),
      }),
    )
  } catch (error) {
    log.error(error, 'Error creating user.')
    store.dispatch(
      createUserError({
        storeKey,
        error: parseUserError(error),
      }),
    )
  }
}

async function updateUserEntitlementHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const data = _get(action.payload, 'data')
  const entitlement = {
    user_uuid: _get(data, 'uuid'),
    id: _get(data, ['entitlement', 'id']),
    content_set_id: _get(data, ['entitlement', 'content_set_id']),
    start: _get(data, ['entitlement', 'start']),
    end: _get(data, ['entitlement', 'end']),
    ecommerce_sku: _get(data, ['entitlement', 'ecommerce_sku']),
    ecommerce_sku_provider: _get(data, ['entitlement', 'ecommerce_sku_provider']),
  }

  store.dispatch(
    clearUserEntitlements({
      storeKey,
    }),
  )

  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      body: entitlement,
    }
    const res = await updateUserEntitlement(options)
    store.dispatch(
      updateUserEntitlementSuccess({
        storeKey,
        data: fromJS(res),
      }),
    )
  } catch (error) {
    log.error(error, 'Error updating entitlement.')
    store.dispatch(
      updateUserEntitlementError({
        storeKey,
        error: parseUserError(error),
      }),
    )
  }
}

async function createUserEntitlementHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const data = _get(action.payload, 'data')
  const entitlement = {
    user_uuid: _get(data, 'uuid'),
    content_set_id: _get(data, ['entitlement', 'content_set_id']),
    start: _get(data, ['entitlement', 'start']),
    end: _get(data, ['entitlement', 'end']),
    ecommerce_sku: _get(data, ['entitlement', 'ecommerce_sku']),
    ecommerce_sku_provider: _get(data, ['entitlement', 'ecommerce_sku_provider']),
  }

  store.dispatch(
    clearUserEntitlements({
      storeKey,
    }),
  )

  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      body: entitlement,
    }
    const res = await createUserEntitlement(options)
    store.dispatch(
      createUserEntitlementSuccess({
        storeKey,
        data: fromJS(res),
      }),
    )
  } catch (error) {
    log.error(error, 'Error updating entitlement.')
    store.dispatch(
      createUserEntitlementError({
        storeKey,
        error: parseUserError(error),
      }),
    )
  }
}

async function updateUserHandler ({ store, action }) {
  const { config, auth, user } = store.getState()
  const currentStatus = user.getIn(['userDetail', 'status'])
  const { data } = action.payload
  const password = _get(data, 'password')
  const first_name = _get(data, 'first_name', '')
  const last_name = _get(data, 'last_name', '')
  const billing_account_id = _get(data, 'billing_account_id', '')
  const billing_account_number = _get(data, 'billing_account_number', '')
  const log_user_account_out_of_all_devices = _get(
    data,
    'log_user_account_out_of_all_devices',
    false,
  )
  const yogaInternationalUserId = user.getIn(['userDetail', 'data', 'yoga_international_user_id'])

  const userData = {
    first_name,
    last_name,
    password: password
      ? {
          updated: _get(data, 'password'),
          current: 'placeholder', // endpoint requires some value here
        }
      : null,
    user_roles: _get(data, 'user_roles'),
    gcsi_user_uuid: _get(data, 'gcsi_user_uuid'),
    status: _get(data, 'status'),
    uuid: _get(data, 'uuid'),
    language: _get(data, 'language' || 'en'),
    billing_account_id: billing_account_id || null,
    billing_account_number: billing_account_number || null,
    log_user_account_out_of_all_devices,
    member_support_notes: _get(data, 'member_support_notes', ''),
  }
  if (userData.password === null) {
    userData.password = undefined
  }
  if (userData.gcsi_user_uuid === '') {
    userData.gcsi_user_uuid = null
  }
  // If we are changing status we also need to reset the temporary blocks
  if (userData.status !== currentStatus) {
    userData.blocked_until = null
    userData.consecutive_failed_login_attempts = 0
  }
  // Dont send encoded fields for YI users
  if (!yogaInternationalUserId) {
    userData.username = _get(data, 'username')
    userData.email = _get(data, 'email')
  }
  try {
    const res = await updateUser({
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      body: userData,
    })
    store.dispatch(
      updateUserSuccess({
        storeKey,
        data: fromJS(res),
      }),
    )
    alert('Successfully Updated User')
  } catch (error) {
    log.error(error, 'Error updating user.')
    store.dispatch(
      updateUserError({
        storeKey,
        error: parseError(error) ?? parseUserError(error),
      }),
    )
  }
}

async function anonymizeUserDataHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { data } = action.payload
  try {
    const response = await anonymizeUserData({ config, auth, ...data })
    const { success } = response
    if (success) {
      const { result } = response
      if (_get(result, 'updatedAuth', false)) {
        store.dispatch(
          anonymizeUserDataSuccess({
            storeKey,
            data: fromJS(result),
          }),
        )
      } else {
        store.dispatch(
          anonymizeUserDataError({
            storeKey,
            error: 'Auth data was not updated, and we think it should have been.',
          }),
        )
      }
    } else {
      store.dispatch(
        anonymizeUserDataError({
          storeKey,
          error: 'Something wrong happened',
        }),
      )
    }
  } catch (error) {
    store.dispatch(
      anonymizeUserDataError({
        storeKey,
        error: `Encountered an error: ${error}`,
      }),
    )
  }
}

async function grantUserBonusDataHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const { data } = action.payload
  try {
    const response = await grantUserBonusData({ config, auth, ...data })
    const { success, result } = response
    if (success) {
      store.dispatch(
        grantUserBonusDataSuccess({
          storeKey,
          data: fromJS({
            result,
          }),
        }),
      )
    } else {
      store.dispatch(
        grantUserBonusDataError({
          storeKey,
          error: `Bonus was not ordered, and we think it should have been: ${result}`,
        }),
      )
    }
  } catch (error) {
    store.dispatch(
      grantUserBonusDataError({
        storeKey,
        error: `Encountered an error: ${error}`,
      }),
    )
  }
}

async function changeAccountOwnerHandler ({ store, action }) {
  const { config, auth } = store.getState()
  const {
    accountId,
    newOwnerUid,
    sendPasswordResetEmail,
    moveZuoraSubscription,
    moveEntitlements,
  } = action.payload

  try {
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'auth']),
      accountId,
      newOwnerUid,
      sendPasswordResetEmail,
      moveZuoraSubscription,
      moveEntitlements,
    }
    const res = await changeAccountOwner(options)
    store.dispatch(
      changeAccountOwnerSuccess({
        storeKey,
        data: fromJS(res),
      }),
    )
  } catch (error) {
    log.error(error, 'Error changing account owner.')
    store.dispatch(
      changeAccountOwnerError({
        storeKey,
        error: parseUserError(error),
      }),
    )
  }
}

export default (store) => (next) => (action) => {
  const { type, payload } = action
  switch (type) {
    case GET_USER_BY_GCSI_USER_UUID:
    case GET_USER_BY_UID:
    case GET_USER_BY_UUID:
      getUserHandler({ store, action })
      break
    case GET_USER_LAST_TRANSACTION:
      getUserLastTransactionHandler({ store, action })
      break
    case GET_USER_GCSI_SUBSCRIPTION:
      getUserGcsiSubscriptionHandler({ store, action })
      break
    case RESET_USER_BLOCK:
      resetUserBlockHandler({ store, action })
      break
    case CREATE_USER:
      createUserHandler({ store, action })
      break
    case UPDATE_USER:
      updateUserHandler({ store, action })
      break
    case UPDATE_USER_ENTITLEMENT:
      updateUserEntitlementHandler({ store, action })
      break
    case CREATE_USER_ENTITLEMENT:
      createUserEntitlementHandler({ store, action })
      break
    case SIMULATE_USER:
      simulateUser({ store, action })
      break
    case ANONYMIZE_USER_DATA:
      anonymizeUserDataHandler({ store, action })
      break
    case GRANT_USER_BONUS:
      grantUserBonusDataHandler({ store, action })
      break
    case CHANGE_ACCOUNT_OWNER:
      changeAccountOwnerHandler({ store, action })
      break
    default:
      break
  }
  next(action)
  // After state update
  switch (type) {
    case CREATE_USER_SUCCESS: {
      // Redirect a successful user update to the detail page
      const { data } = payload
      const href = createLocationHref(
        Map({
          data: Map({
            pathname: '/user-detail',
            query: Map({ uid: data.get('uid') }),
          }),
        }),
      )
      document.location.href = href
      break
    }
    default:
      break
  }
}
